"use client"
import Link from "next/link";
import dynamic from "next/dynamic";
import LazyImage from "components/LazyImage";

import logExternalLinkClick from "lib/ga/externalLinkClick";
import logInternalLinkClick from "lib/ga/internalLinkClick";
import logPageView from "lib/ga/pageView";
import logPortfolioPageView from "lib/ga/portfolioPageView";
import useMount from "react-use/lib/useMount";
import styles from './britishland.module.css';

const Videos = dynamic(() => import("./Video"), {
  ssr: false,
});

type Props = {
  portfolio: {
    id: string,
  }
}

const Britishland = ({ portfolio }: Props) => {
  const activePortfolio = portfolio;
  useMount(() => {
    logPageView({ url: window.location.pathname + window.location.search });
    logPortfolioPageView({ portfolio_id: activePortfolio.id });
  });
  return (
    <>
      <div className={styles.Header}>
        <div className={styles.HeaderInner}>
          <Link href="/portfolio/BritishLand" legacyBehavior prefetch={false}>
            <a className={styles.Logo} onClick={(e) => logInternalLinkClick("BL Logo Link", "/portfolio/BritishLand", undefined, activePortfolio.id)}></a>
          </Link>
          <div className={styles.Title}>
            <h1>Retail & Leisure</h1>
          </div>
        </div>
      </div>

      <div className={styles.Hero}>
        <LazyImage
          src={`/images/portfolios/britishland/br-hero.jpg`}
          sources={[
            {
              srcSet: `/images/portfolios/britishland/br-hero.webp`,
              type: "image/webp",
            },
            {
              srcSet: `/images/portfolios/britishland/br-hero.jpg`,
              type: "image/jpg",
            },
          ]}
          alt="British Land's Portfolio"
          layout="fill"
          objectFit="cover"
        // priority
        />
      </div>

      <div className={styles.Categories}>
        <Link href="/portfolio/BritishLand/schemes/retail-parks" passHref prefetch={false} legacyBehavior>
          <a className={styles.Category}
            onClick={(e) => logInternalLinkClick("Regional Schemes", "/portfolio/BritishLand/schemes/retail-parks", undefined, activePortfolio.id)}
          >
            Retail Parks
          </a>
        </Link>
        <Link href="/portfolio/BritishLand/schemes/shopping-centres" passHref prefetch={false} legacyBehavior>
          <a className={styles.Category}
            onClick={(e) => logInternalLinkClick("Local Schemes", "/portfolio/britishland/schemes/shopping-centres", undefined, activePortfolio.id)}
          >
            Shopping Centres
          </a>
        </Link>
      </div>
      <div className={styles.ContentTitle}>
        <div>British Land’s shopping centres and retail parks are among the best in the UK</div>
      </div>
      <div className={styles.Body}>
        <div className={styles.BodyInner}>
          <h2>Our Vision:</h2>
          <p>
            Our purpose is to create and manage outstanding places which deliver positive outcomes for all our stakeholders on a long term, sustainable basis.
          </p>
          <p>
            We call this <span>Places People Prefer</span>.
          </p>
          <p>
            Our portfolio is focussed on three key sectors, of which 32% is made up of retail parks. We are the largest retail park owner and operator in the UK with 52 individual assets at 98% occupancy.            </p>
          <p>
            Our parks are located in prime locations and are home to some of the biggest brands in retail. We are experts at nurturing and curating our parks, so they deliver for our customers and their visitors.            </p>
           <Videos />

          <a
            className={styles.ExternalLink}
            href="https://www.britishland.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => logExternalLinkClick("Website Link", "https://www.britishland.com", undefined, activePortfolio.id, undefined)}
          >
            BRITISHLAND.COM
          </a>
        </div>
      </div>
    </>
  );
};

export default Britishland;
